import type { BillingCadence } from '../config/commercialPlans';
import {
  isEnterpriseSeatBand,
  type PricedSeatBandCode,
  type SeatBandCode,
} from '../config/seatBands';

const STARTER_REPRESENTATIVE_SEAT_COUNT = 3;
const GROWTH_REPRESENTATIVE_SEAT_COUNT = 10;

export const REPRESENTATIVE_SEAT_COUNTS: Record<PricedSeatBandCode, number> = {
  '1-3': STARTER_REPRESENTATIVE_SEAT_COUNT,
  '4-49': GROWTH_REPRESENTATIVE_SEAT_COUNT,
};

export function getRepresentativeSeatCount(
  seatBand: SeatBandCode
): number | null {
  if (isEnterpriseSeatBand(seatBand)) {
    return null;
  }

  return REPRESENTATIVE_SEAT_COUNTS[seatBand];
}

export function getTeamTotalUsd(
  perLicenseUsd: number,
  seatCount: number
): number {
  return perLicenseUsd * seatCount;
}

export function shouldShowMarketBenchmark(seatBand: SeatBandCode): boolean {
  return seatBand === '4-49';
}

export function getTeamTotalPeriodKey(
  billingCadence: BillingCadence
): 'pricing:marketing.teamTotalPeriodMonthly' | 'pricing:marketing.teamTotalPeriodAnnual' {
  return billingCadence === 'annual'
    ? 'pricing:marketing.teamTotalPeriodAnnual'
    : 'pricing:marketing.teamTotalPeriodMonthly';
}
